module.exports = `fragment brands on Contentstack_brands {
    reference {
      title
      category
    }
  }`;